import {
  gql 
} from "@apollo/client";

export const ADD_INFLUENCER_PROGRAM = gql`
    mutation addInfluencerProgram(
        $email: String!
        $firstname: String!
        $lastname: String!
        $instagram: Int
        $instagramurl: String
        $pinterest: Int
        $pinteresturl: String
        $facebook: Int
        $facebookurl: String
        $tiktok: Int
        $tiktokurl: String
        $youtube: Int
        $youtubeurl: String
        $blog: Int
        $blogurl: String
        $customerType: Int!
        $otherCustomerType: String
    ) {
        addInfluencerProgram(
            input: {
                email: $email
                firstname: $firstname
                lastname: $lastname
                instagram: $instagram
                instagramurl: $instagramurl
                pinterest: $pinterest
                pinteresturl: $pinteresturl
                facebook: $facebook
                facebookurl: $facebookurl
                tiktok: $tiktok
                tiktokurl: $tiktokurl
                youtube: $youtube
                youtubeurl: $youtubeurl
                blog: $blog
                blogurl: $blogurl
                customerType: $customerType
                otherCustomerType: $otherCustomerType
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addInfluencerProgramMutation: ADD_INFLUENCER_PROGRAM
};
